/** The product name, in one place so the shell, the sign-in page, and the tab agree. */
export const APP_NAME = 'VGS Work Order Management';
export const APP_MARK = 'VGS';
